module.exports = __webpack_public_path__ + "media/images/page/service_logo-freelance-d59fb363d531995b9984ab85012aef42.png";